import { BrowserRouter, Route, Routes } from "react-router-dom";
import Layout from "./Layout/Index";
import Home from "./Pages/Home/page";
import Driver from "./Pages/Drivers/page";
import Owner from "./Pages/Owners/page";
import Track from "./Pages/Track/page";
import Truck from "./Pages/Truck/page";
import Arca from "./Pages/Arca/page";
import Cup from "./Pages/Cup/page";
import Xfinity from "./Pages/Xfinity/page";
import Modifier from "./Pages/Modifier/page";
import Imsa from "./Pages/Imsa/page";
import IndyCar from "./Pages/IndyCar/page";
import F1 from "./Pages/F1/page";
import Random from "./Pages/Random/page";
import Riderdatatable from "./Components/DriverTable/Riderdatatable";
import Ridernametable from "./Components/DriverTable/Ridernametable";
import Riderrace from "./Components/DriverTable/Riderrace";

function App() {

  return (
    <>
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route exact path="/" element={<Home />} />
            <Route exact path="/driver" element={<Driver />} />
            <Route exact path="/owner" element={<Owner />} />
            <Route exact path="/track" element={<Track />} />
            <Route exact path="/cup" element={<Cup />} />
            <Route exact path="/xfinity" element={<Xfinity />} />
            <Route exact path="/truck" element={<Truck />} />
            <Route exact path="/acra" element={<Arca />} />
            <Route exact path="/modified" element={<Modifier />} />
            <Route exact path="/imsa" element={<Imsa />} />
            <Route exact path="/indycar" element={<IndyCar />} />
            <Route exact path="/f1" element={<F1 />} />
            <Route exact path="/random" element={<Random />} />
            <Route exact path="/driver/:id" element={<Riderdatatable />} />
            <Route exact path="/ridernametable/:id" element={<Ridernametable />} />
            <Route exact path="/riderrace/:id" element={<Riderrace />} />
          </Routes>
        </Layout>
      </BrowserRouter>
    </>
  );
}

export default App;
